import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {SEOUL_MILEAGE_TERMS_KEY} from '@di-shared/features/mileage/agreement/const';
import {useSuspenseQuery} from '@tanstack/react-query';
import {useNavigate} from 'react-router';
import useMileageAgreement from '@di-shared/features/mileage/agreement/useMileageAgreement';
import {ROUTE_PATHS} from '@di-shared/routes';

interface MileageAgreementDetailProps {
  vin: string;
  termsId: string;
}

function MileageAgreementDetail({vin, termsId}: MileageAgreementDetailProps) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();
  const {agreeTerms} = useMileageAgreement({terms: []});
  const {data: term} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.termsController.getOptionalTerms1), vin],
    queryFn: () => diApi.termsController.getOptionalTerms1({termsKey: SEOUL_MILEAGE_TERMS_KEY}),
    select: (data) => data.data.optionalTermsList.find((term) => term.termsId.toString() === termsId),
  });
  return (
    <>
      <main
        id="content"
        className="content page_eco_mileage"
      >
        <section className="section section_mileage_consent">
          <div className="section_heading">
            <h2 className="section_heading_title">{term?.title}</h2>
          </div>
          <div
            className="mileage_consent_detail"
            style={{whiteSpace: 'pre-wrap'}}
            dangerouslySetInnerHTML={{
              __html: term?.content || '',
            }}
          ></div>
        </section>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => {
            agreeTerms(termsId);
            navigate(ROUTE_PATHS.MILEAGE_AGREEMENT.getFullPath(vin) + location.search, {replace: true});
          }}
        >
          {t('T10114')}
        </button>
      </div>
    </>
  );
}

export default MileageAgreementDetail;

export function MileageAgreementDetailLoading() {
  const {t} = useInferableTranslation();
  return (
    <>
      <main
        id="content"
        className="content page_eco_mileage"
      >
        <section className="section section_mileage_consent">
          <div className="section_heading skeleton">
            <h2 className="section_heading_title skeleton">{t('T10114')}</h2>
          </div>
          <div
            className="mileage_consent_detail skeleton"
            style={{height: '200px'}}
          ></div>
        </section>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          disabled
        >
          {t('T10114')}
        </button>
      </div>
    </>
  );
}
